import React from "react";
import ContratoService from "../../services/ContratoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaContrato extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: ContratoService,
            labels: {
                title: 'Lista de Contrato(s)',
                btnNewRegister: 'Contrato',
            },
            keyItem: 'idContrato',
            urlForm: '/CadContrato',
            itensFilter: ["idContrato", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idContrato}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}